<div class="settings-button toolbar-button details top-settings" *ngIf="grid">
    <button (click)="onClick()" type="button" class="btn btn-default btn-sm settings-icon">
        <i class="fas fa-cogs"></i>
    </button>
</div>